var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShield = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.478 11.306 3.605 3.428 7.965-7.63-1.072-1.042-6.9 6.613-2.54-2.411-1.058 1.042Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m12.002 23.661.497.333.006.006.43-.288c6.298-4.176 10.062-11.088 10.062-18.475V3.121L12.46 0 2 3.153v2.072c0 7.36 3.738 14.254 10.002 18.436ZM3.515 5.225v-.992l8.95-2.698L21.483 4.2v1.03c0 6.74-3.347 13.046-8.977 16.978-5.636-3.932-8.99-10.25-8.99-16.984Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShield);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Shield.b47caa0a96e88f6ba07bf9d3ee4241d6.svg";